<template>
  <div class="down" @click="downClickHandler">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      t="1637911067520"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      p-id="8703"
      width="32"
      height="32"
    >
      <path
        d="M534.09109116 6.71115421l0 662.73273745L472.72694864 669.44389165 472.72694865 6.71115421l61.3641425 2e-8z"
        fill="#0080cc"
        p-id="8704"
      ></path>
      <path
        d="M717.71907109 665.71307852L508.13772668 1022.56779958l-215.24570478-356.85472106 424.82704919 0z"
        fill="#0080cc"
        p-id="8705"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  methods: {
    downClickHandler() {
      this.$emit("downclickhandler");
    },
  },
};
</script>

<style scoped>
.down {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 55px;
  height: 55px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.down svg {
  width: 20px;
  animation: down 1.5s infinite linear;
  position: relative;
}
@keyframes down {
  0% {
    top: -5px;
    opacity: 1;
  }
  100% {
    top: 15px;
    opacity: 0;
  }
}
</style>
